import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@material-ui/core'

const StudentCpfNotFoundDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} disableRestoreFocus>
    <DialogTitle>CPF não encontrado!</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Seu cadastro está desatualizado e não será possível realizar a rematrícula online!
        Entre em contato com sua escola e solicite inclusão do CPF.
        Importante: Caso não tenha um CPF, solicite a escola para realizar sua rematrícula.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary" autoFocus>
        Aceitar
      </Button>
    </DialogActions>
  </Dialog>
)

export default StudentCpfNotFoundDialog
